import React, {useState} from 'react';
import Switch from "react-switch";
import { useTheme } from '../../../../context/ThemeContext';

const ACCENT_COLOR = '#FAFAFA'; // var(--text-common-elements-accent-deep-blue-green) in dark
const TRACK_COLOR_DARK = '#2B2B2B';

const PlanTypeSwitcher = props => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const trackColor = isDark ? TRACK_COLOR_DARK : '#FFFFFF';
  const handleColor = isDark ? ACCENT_COLOR : '#006D6F';

  // switch on -> term_life
  // switch off -> final_expense
  const handleChange = nextChecked => {
    if(nextChecked)
      props.toggleProductType("term_life");
    else 
      props.toggleProductType("final_expense");
  };

  return (
    <label className={`d-flex align-items-center planTypeSwitcherWrapper ${props.containerClass}`}>
      <span className={props.productType === "term_life" ? "deepGray":"active"}>{props.label1}</span>
      <Switch 
        onChange={handleChange}
        checked={props.productType === "term_life"} 
        onColor={trackColor}
        offColor={trackColor}
        onHandleColor={handleColor}
        offHandleColor={handleColor}
        uncheckedIcon={false} 
        checkedIcon={false} 
        className="planTypeSwitcher"
        boxShadow="none"
        activeBoxShadow="none"
        width={66}
        height={28}
      />
      <span className={props.productType === "term_life" ? "active":"deepGray"}>{props.label2}</span>
    </label>
  );
};


PlanTypeSwitcher.defaultProps = {
  label1: 'Whole',
  label2: "Term"
};

export default PlanTypeSwitcher;
